"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayRowStore = void 0;
/**
 * RowStore backed by an array.
 */
var ArrayRowStore = /** @class */ (function () {
    function ArrayRowStore(rows) {
        this.rows = rows;
    }
    ArrayRowStore.prototype.getItems = function (start, end, rowHandler) {
        rowHandler(this.rows);
    };
    return ArrayRowStore;
}());
exports.ArrayRowStore = ArrayRowStore;
//# sourceMappingURL=ArrayRowStore.js.map